import React, { Component } from "react";
import { Container, Row, Col, Label } from "reactstrap";
import { inject, observer } from "mobx-react";
import { Link, Redirect } from "react-router-dom";
import _ from 'lodash';
import DataWrapper from "../../../principal/containers/DataWrapper";
import ModalAviso from "../../../comum/components/ModalAviso";
import Footer from "../../../comum/components/Footer";
import { IconeCarregar, IconeSetaEsquerda } from "../../../comum/components/Icones";
import NotaFiscalForm from "../components/NotaFiscalForm";
import NotaFiscalCadastrarStore from "../stores/NotaFiscalCadastarStore";
import ModalMultiplaEscolha from "../../../comum/components/ModalMultiplaEscolha";

@inject("store")
@DataWrapper
@observer
export class NotaFiscalCadastrar extends Component {
    constructor(props) {
        super(props);
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.appStore = this.props.store.appStore;

        this.isRIG = process.env.rig;
        this.isSSA = !process.env.rig;

        this.controller = new NotaFiscalCadastrarStore();

        this.editar = _.get(this.props.match, `params.id`);
        this.duplicar = _.get(this.props.location, `duplicar`);

        this.state = { redirecionar: false }
    };

    async componentDidMount() {
        this.tituloPaginaStore.setTitulo(`${this.controller.idNota && this.editar ? "" : "Nova"} Nota Fiscal`);
        this.appStore.showTopbar(true);
        this.appStore.showVoltarTopBar(true, '/agendamento-nota-fiscal');
        this.controller.loading = true;
        await this.controller.carregarTransportadorasNotaFiscal();

        if (this.editar) {
            this.controller.setIdNota(_.get(this.props.match, `params.id`));
            this.controller.carregarNota(this.controller.idNota);
        }

        this.controller.loading = false;
    };

    handleFinalizar = () => {
        this.controller.idNota && this.editar ? this.controller.onClickEditarNotaFiscal() : this.controller.onClickSalvarNotaFiscal();
    };

    handleRedirect = (url) => {
        this.setState({ redirecionar: true, path: url });
        this.controller.sucesso = false;
    };

    handleReload = () => {
        this.controller.sucesso = false;
        this.props.history.go('/agendamento-nota-fiscal/cadastro');
    };

    modalAviso() {
        if (this.controller.sucesso) {
            return <ModalMultiplaEscolha titulo={"Concluído"}
                mensagem={this.controller.mensagemSucesso}>
                {
                    <div className="justify-content-end">
                        {this.editar && <Label className="btn-primary" onClick={() => { this.controller.sucesso = false; window.location.reload(); }}>Continuar editando</Label>}
                        <Label className="btn-primary" onClick={() => this.handleRedirect('/agendamento-nota-fiscal')}>Cadastrar / Consultar Notas Fiscais</Label>
                    </div>
                }

            </ModalMultiplaEscolha>

        } else if (this.controller.mensagemErro && this.controller.mensagemErro.length) {

            if (this.controller.mensagemErro.length > 0) {
                return <ModalAviso onClickFechar={() => this.controller.fecharModais()}>
                    {this.controller.mensagemErro.map((msg, i) => <h2 key={i}>{msg}</h2>)}
                </ModalAviso>
            } else {
                return <ModalAviso onClickFechar={() => this.controller.fecharModais()}>
                    <h2>Preencha os Campos Obrigatórios da Nota Antes de Salvar</h2>
                </ModalAviso>
            }
        }
    }

    notaNaoEncontrada() {
        return <div className="content-panel mb-5 mt-3">
            <Container fluid>
                <Row>
                    <Col xl={12}><h2>Nota Fiscal Não Encontrada!</h2></Col>
                    <Col xl={12}><Link to={'/agendamento-nota-fiscal/'}>Ir para Tela de Filtros</Link></Col>
                </Row>
            </Container>
        </div>
    };

    render() {
        if (this.state.redirecionar) {
            return <Redirect to={this.state.path} />
        }
        return (
            <div className="form-wrapper">
                {!this.controller.notaNaoEncontrada ?
                    <div className="content-panel mb-5">
                        <Container fluid>
                            <Row>
                                <Col xl={12}>
                                    <NotaFiscalForm
                                        dadosNota={this.controller.dadosNotaFiscal}
                                        controller={this.controller}
                                        removerNCM={this.controller.removerNCM}
                                        transportadorasNotaFiscal={this.controller.transportadorasNotaFiscal}
                                        adicionarNovoContainer={this.controller.abrirInserirNovoNotaFiscalContainer}
                                        removerContainer={this.controller.removerNotaFiscalContainer}
                                        adicionarNovoNCM={this.controller.abrirInserirNovoNotaFiscalNCM}
                                        setDado={this.controller.setDadosNotaFiscal}
                                        notaSelecionada={_.get(this.props.location, `notaFiscalSel`)}
                                        importacaoXML={_.get(this.props.location, `importacaoXML`)}
                                        editar={this.controller.idNota}
                                        loading={this.controller.loading}
                                        duplicar={this.duplicar}
                                        isRIG={this.isRIG}
                                        isSSA={this.isSSA}
                                        salvo={this.controller.contemErro}
                                        setBagagemFlag={this.controller.carregaCamposObrigatoriosNotasFiscais}
                                    />
                                </Col>
                            </Row>
                        </Container>
                        {this.modalAviso()}
                        <Footer className="justify-content-end">
                            <div>
                                {!this.controller.salvar ?
                                    <Label className="btn-primary"
                                        hidden={!(this.controller.dadosNotaFiscal.Nf != null && this.controller.dadosNotaFiscal.Nf.Status === "P")}
                                        onClick={this.handleFinalizar}>{this.controller.idNota && this.editar ? 'ALTERAR' : 'SALVAR'} NOTA FISCAL</Label>
                                    : <IconeCarregar tamanho="2x" />
                                }
                            </div>
                        </Footer>
                    </div>
                    :
                    this.notaNaoEncontrada()
                }
            </div>

        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/agendamento/nota-fiscal-cadastrar/tela/NotaFiscalCadastrar.js